import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/index/2-xl.avif")